"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBinRaster = exports.BinRaster = void 0;
const fetchHelp_1 = require("./fetchHelp");
class BinRaster {
    constructor(arrayBuf, id) {
        this._data = new DataView(arrayBuf);
        this.id = id;
        const getHeaderValue = (i) => this._data.getFloat64(i << 3, false);
        this.height = getHeaderValue(0);
        this.width = getHeaderValue(1);
        this.stats = {
            min: getHeaderValue(2),
            max: getHeaderValue(3)
        };
        this.boundingBox = {
            latMin: getHeaderValue(4),
            latMax: getHeaderValue(5),
            lonMin: getHeaderValue(6),
            lonMax: getHeaderValue(7)
        };
    }
    getValue(y, x) {
        const i = (this.height - 1 - y) * this.width + x;
        return this._data.getFloat64((i << 3) + 64, false);
    }
}
exports.BinRaster = BinRaster;
function getBinRaster(id, url, ...keyValues) {
    const fullUrl = url + (0, fetchHelp_1.getUrlQuery)(keyValues);
    return fetch(fullUrl, {
        headers: {
            'Accept': 'application/octet-stream'
        }
    })
        .then(fetchHelp_1.checkStatus)
        .then(response => response.arrayBuffer())
        .then(response => {
        return new BinRaster(response, id || fullUrl);
    });
}
exports.getBinRaster = getBinRaster;
